<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ cardname }}
    </div>
    <div class="p-2">
      <component
        v-for="prop in get_flexprops()"
        v-bind:is="MainComponent(prop.type)"
        :key="prop.id"
        :options="prop.options"
        :name="prop.name"
        :value="prop.value"
        :label="prop.label"
        :disabled="disabled"
        @FlexpropDataChange="onFlexpropDataChange"
      />
      <FormulateInput
        type="submit"
        label="Opslaan"
        @click="submitHandler"
        :input-class="['btn', 'btn-blue', this.disabled ? 'disabled' : '']"
      />

      <p class="text-red-600 ml-4 mb-2 mt-0">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
import InputString from "./InputString.vue";
import InputInteger from "./InputInteger.vue";
import InputBoolean from "./InputBoolean.vue";
import InputFloat from "./InputFloat.vue";

export default {
  name: "FlexpropCard",
  props: ["vzid", "schema", "values", "cardname", "disabled", "test-mode"],
  components: {
    InputBoolean,
    InputInteger,
    InputString,
    InputFloat
  },
  data() {
    return {
      msg: null,
      defaultkeylist: ["id", "type", "label"],
      submitdata: this.values
    };
  },
  methods: {
    onFlexpropDataChange: function(value) {
      this.submitdata[value.key] = value.value;
    },
    get_flexprops: function() {
      const properties = Object.entries(
        this.schema.properties
      ).filter(([_, v]) => this.cardname.includes(v.card));

      let flexprops = [];
      for (const [key, value] of properties) {
        let options = Object.fromEntries(
          Object.entries(value).filter(
            ([k, _]) => !this.defaultkeylist.includes(k)
          )
        );
        flexprops.push({
          id: value["id"],
          type: value["type"],
          label: value["label"],
          name: key,
          options: options,
          value: key in this.values ? this.values[key] : null
        });
      }
      return flexprops;
    },
    hideMsg: function() {
      this.msg = null;
    },
    parseResponse: function(ok, msg) {
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    },
    MainComponent: function(type) {
      return {
        string: "InputString",
        number: "InputFloat",
        integer: "InputInteger",
        boolean: "InputBoolean"
      }[type];
    },
    submitHandler: async function() {
      if (this.testMode === true) {
        this.parseResponse(false, "Dit is een testkaart");
        return;
      }
      const [ok, msg] = await this.$store.dispatch("updateVoorziening", {
        id: this.vzid,
        properties: {
          flexprops: this.submitdata
        }
      });
      this.parseResponse(ok, msg);
    }
  },
  watch: {
    msg(_) {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  }
};
</script>

<style>
.formulate-form {
  @apply font-opensans;
}

.formulate-input-wrapper {
  @apply mb-2 grid grid-cols-2;
}

.disabled {
  @apply appearance-none bg-transparent;
}

.editMode {
  @apply bg-transparent border-b border-gray-500 border-dashed;
}

.formulate-input-label {
  @apply font-bold;
}

.btn {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}
.btn:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}

.btn.disabled {
  @apply hidden;
}
</style>
